import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { CrossIcon } from "components/tabs/TabTitle";

export const createInitialJournalGridData = () => [
  {
    journalLineId: 1,
    CreditAmount: 0,
    DebitAmount: 0,
    NominalInfo: {
      nominalRef: null,
    },
  },
  {
    journalLineId: 2,
    CreditAmount: 0,
    DebitAmount: 0,
    NominalInfo: {
      nominalRef: null,
    },
  },
];

export const removeJournalRow = (rows, item) => {
  const index = rows.findIndex(
    (record) => record.journalLineId === item.journalLineId,
  );
  if (index < 0) {
    return rows;
  }
  const next = [...rows];
  next.splice(index, 1);
  return next;
};

export const JournalRowRender = (props) => {
  const trProps = {
    ...props.tr.props,
    style: { textAlign: "right" },
  };
  return React.cloneElement(props.tr, { ...trProps }, props.tr.props.children);
};

export const JournalCommandCell = (props) => {
  const { dataItem } = props;
  return (
    <td className="k-command-cell">
      <div className="cursor-pointer">
        <CrossIcon onClick={() => props.remove(dataItem)} />
      </div>
    </td>
  );
};

export const JournalNominalCell = (props) => {
  const [filterSet, setFilterSet] = React.useState([]);
  const localizedData = props.nominals || [];

  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  const filterData = (filter) => {
    const next = localizedData.slice();
    return filterBy(next, filter);
  };

  const filterChange = (event) => {
    setFilterSet(filterData(event.filter));
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];
  const resolvedValue =
    dataValue?.nominalRef != null
      ? localizedData.find((x) => x.nominalRef === dataValue.nominalRef) || {
          ...dataValue,
          display: dataValue.display || dataValue.nominalRef,
        }
      : null;

  const hasAmount =
    (Number(dataItem?.CreditAmount) || 0) !== 0 ||
    (Number(dataItem?.DebitAmount) || 0) !== 0;
  const isMissingNominal = !dataItem?.NominalInfo?.nominalRef;
  const showError =
    Boolean(props.showValidation) &&
    isMissingNominal &&
    (hasAmount || Boolean(props.noAmountsEntered));

  return (
    <td>
      <ComboBox
        style={{
          height: "35px",
          border: showError ? "1px solid red" : undefined,
        }}
        className="d-flex justify-content-start align-items-center me-auto"
        onChange={handleChange}
        value={resolvedValue}
        data={filterSet.length > 0 ? filterSet : localizedData}
        textField="display"
        dataItemKey="nominalRef"
        filterable={true}
        onFilterChange={filterChange}
        placeholder="Select Nominal Ref"
        allowCustom={false}
      />
    </td>
  );
};

export const JournalNominalNameCell = (props) => {
  const localizedData = props.nominals || [];
  const nominalRef = props.dataItem.NominalInfo?.nominalRef;
  const resolved = nominalRef
    ? localizedData.find((x) => x.nominalRef === nominalRef)
    : null;
  const nominalName =
    resolved?.nominalName || props.dataItem.NominalInfo?.nominalName || "";
  return <td style={{ textAlign: "left" }}>{nominalName}</td>;
};

export const JournalNominalTypeCell = (props) => {
  const localizedData = props.nominals || [];
  const nominalRef = props.dataItem.NominalInfo?.nominalRef;
  const resolved = nominalRef
    ? localizedData.find((x) => x.nominalRef === nominalRef)
    : null;
  const type = resolved?.typeName || props.dataItem.NominalInfo?.typeName || "";
  const subType =
    resolved?.subTypeName || props.dataItem.NominalInfo?.subTypeName || "";
  return (
    <td style={{ textAlign: "left" }}>
      {type} {subType}
    </td>
  );
};

export const JournalAmountCell = (props) => {
  const row = props.dataItem || {};
  const value =
    row[props.field] !== undefined && row[props.field] !== null
      ? row[props.field]
      : 0;

  const credit = Number(row?.CreditAmount) || 0;
  const debit = Number(row?.DebitAmount) || 0;
  const highlightEmptyAmounts =
    Boolean(props.showValidation) &&
    Boolean(props.noAmountsEntered) &&
    credit === 0 &&
    debit === 0;

  return (
    <td className="right-align-full">
      <NumericTextBox
        format={"n2"}
        value={value}
        placeholder="0.00"
        className="m-2"
        style={{
          height: "35px",
          border: highlightEmptyAmounts ? "1px solid red" : undefined,
        }}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange({
              dataIndex: 0,
              dataItem: props.dataItem,
              field: props.field,
              syntheticEvent: e.syntheticEvent,
              value: e.value,
            });
          }
        }}
        spinners={false}
      />
    </td>
  );
};
